import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ResourcesHero } from '../components/resources/ResourcesHero';
import { ResourcesNewsletter } from '../components/resources/ResourcesNewsletter';
import { ResourcesVideo } from '../components/resources/ResourcesVideo';
import { ResourcesPodcasts } from '../components/resources/ResourcesPodcasts';
import { ResourcesClosingCta } from '../components/resources/ResourcesClosingCta';
export function ResourcesPage() {
  return <div className="min-h-screen flex flex-col w-full bg-white font-body" data-id="element-509" data-mp="332y2p4l8vm28">
      <Navigation data-id="element-510" data-mp="2y3v1xwcas202" />
      <main className="flex-grow" data-id="element-511" data-mp="2y5fvpjqsfgwv">
        <ResourcesHero data-id="element-512" data-mp="2y6hhai5fjlsu" />
        <ResourcesNewsletter data-id="element-513" data-mp="2t638uyzx29ua" />
        <ResourcesVideo data-id="element-514" data-mp="2t6v4uaxfe9l3" />
        {/* <ResourcesPodcasts /> */}
        <ResourcesClosingCta data-id="element-515" data-mp="wd1eynzzcii1" />
      </main>
      <Footer data-id="element-516" data-mp="wcrnevzae3a8" />
    </div>;
}